import React, { useEffect, useState, useRef } from 'react'

import { useStoreContext } from 'hooks/StoreContext'
import useSiteMessages from 'hooks/useSiteMessages'
import useAutoFocus from 'hooks/useAutoFocus'

import Tabs from 'components/Tabs'
import UpdateDetail from 'pages/Updates/UpdateDetail'

import Api from 'services/api'
import GA4 from 'helpers/ga4'

import { LoadingSinglePanePage, PageTitle, SinglePanePage } from 'styles/shared'

const Updates = () => {
  useSiteMessages({ getPublishedOnly: true })

  const title = useRef(null)

  const { siteMessages, areSiteMessagesLoaded } = useStoreContext()
  const [unreadSiteMessageIds, setUnreadSiteMessageIds] = useState(null)
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [areUnreadSiteMessageIdsLoaded, setAreUnreadSiteMessageIdsLoaded] = useState(false)
  const [areArchivedSiteMessageIdsLoaded, setAreArchivedSiteMessageIdsLoaded] = useState(false)
  const [areRemovedSiteMessageIdsLoaded, setAreRemovedSiteMessageIdsLoaded] = useState(false)
  const [filteredSiteMessages, setFilteredSiteMessages] = useState([])
  const [archivedSiteMessages, setArchivedSiteMessages] = useState([])
  const [refreshTimestamp, setRefreshTimestamp] = useState(Date.now())

  const isLoaded = areUnreadSiteMessageIdsLoaded && areArchivedSiteMessageIdsLoaded && areRemovedSiteMessageIdsLoaded

  useAutoFocus({ isLoaded, element: title })

  useEffect(() => {
    let cancelled = false

    if (areSiteMessagesLoaded) {
      Api.SiteMessagesUserRead.getUnread().then((res) => {
        if (cancelled) return

        setUnreadSiteMessageIds(res.siteMessageIds)
        setAreUnreadSiteMessageIdsLoaded(true)

        Api.SiteMessagesUserRead.create(res)
      })

      Api.SiteMessagesUserRead.getArchived().then((res) => {
        if (cancelled) return

        setArchivedSiteMessages(siteMessages.filter((siteMessage) => res.siteMessageIds?.includes(siteMessage.id)))
        setAreArchivedSiteMessageIdsLoaded(true)
      })

      Api.SiteMessagesUserRead.getRemoved().then((res) => {
        if (cancelled) return

        setFilteredSiteMessages(siteMessages.filter((siteMessage) => !res.siteMessageIds?.includes(siteMessage.id)))
        setAreRemovedSiteMessageIdsLoaded(true)
      })
    }

    return () => { cancelled = true }
  }, [areSiteMessagesLoaded, refreshTimestamp, siteMessages])

  const onClickCallback = (action) => {
    const eventData = { category: 'Updates', action }

    GA4.sendEvent(eventData)
  }

  const onClickAction = (siteMessageId, action) => {
    if (action === 'archive') {
      Api.SiteMessagesUserRead.archive(siteMessageId).then(() => { setRefreshTimestamp(Date.now()) })
    } else if (action === 'restore') {
      Api.SiteMessagesUserRead.restore(siteMessageId).then(() => { setRefreshTimestamp(Date.now()) })
    } else {
      if (confirm('Are you sure you want to delete this message? This cannot be undone.')) {
        Api.SiteMessagesUserRead.remove(siteMessageId).then(() => { setRefreshTimestamp(Date.now()) })
      }
    }
  }

  if (!isLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <SinglePanePage>
      <PageTitle ref={title}>Updates</PageTitle>

      <Tabs
        activeTabIndex={activeTabIndex}
        onSelectTabIndexCallback={(index) => setActiveTabIndex(index)}
        tabItems={[
          {
            key: 0,
            header: 'Current',
            details:
  <UpdateDetail
                filteredSiteMessages={filteredSiteMessages}
                unreadSiteMessageIds={unreadSiteMessageIds}
                onClickCallback={onClickCallback}
                onClickAction={onClickAction}
                tabSelection={'Current'}
  />
          },
          {
            key: 1,
            header: 'Archive',
            details:
  <UpdateDetail
                filteredSiteMessages={archivedSiteMessages}
                unreadSiteMessageIds={[]}
                onClickCallback={onClickCallback}
                onClickAction={onClickAction}
                tabSelection={'Archive'}
  />
          }
        ]}
      />
    </SinglePanePage>
  )
}

export default Updates
